import { useQuery } from '@apollo/client/react';
import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PotreeSourcesContext } from '../../contexts/PotreeSourcesContext';
import { PROJECT } from '../../graphql/project';
import { ProjectByIdQuery, ProjectByIdQueryVariables } from '../../types/graphqlTypes';
import { stats } from '../../potree/potreeState';

export const useProject = () => {
  const { isLoaded: sourcesLoaded } = useContext(PotreeSourcesContext);
  const { projectId = '' } = useParams();
  const projectQuery = useQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(PROJECT, {
    variables: { projectId },
  });
  useEffect(() => {
    if (!projectQuery.loading && sourcesLoaded) stats.startRender = performance.now();
  }, [projectQuery.loading, sourcesLoaded]);

  return projectQuery;
};
